import React, { useState } from 'react';
import NavButton from '../../components/ul/NavButton';
import { Menu, X } from 'lucide-react';

const Policy_Navbar = ({ onClick, label, className, icon, disabled, selectState }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="text-main-font w-full">
            <div className="flex justify-between items-center">
                {/* Mobile menu button */}
                <button
                    className="lg:hidden p-2 rounded-lg hover:bg-main-bg transition-colors"
                    onClick={toggleMobileMenu}
                    aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                >
                    {mobileMenuOpen ? (
                        <X size={22} className="text-main-font" />
                    ) : (
                        <Menu size={22} className="text-main-font" />
                    )}
                </button>

                {/* Desktop navigation */}
                <ul className="hidden lg:flex items-center gap-4">
                    <li>
                        <NavButton to="/policy" btnName="Privacy Policy" selectState={selectState === "policy"} />
                    </li>
                    <li>
                        <NavButton to="/policy/terms" btnName="Terms & Conditions" selectState={selectState === "terms"} />
                    </li>
                    <li>
                        <NavButton to="/policy/ios" btnName="Privacy Policy (iOS)" selectState={selectState === "iospolicy"} />
                    </li>
                    <li>
                        <NavButton to="/policy/terms/ios" btnName="Terms & Conditions (iOS)" selectState={selectState === "iosterms"} />
                    </li>
                </ul>

                {/* Action button */}
                <div className="hidden sm:block">
                    <button onClick={onClick} disabled={disabled} className={className}>
                        <div className="flex items-center gap-2">
                            {icon}
                            <span>{label}</span>
                        </div>
                    </button>
                </div>
            </div>

            {/* Mobile navigation */}
            {mobileMenuOpen && (
                <div className="lg:hidden mt-4 bg-main-white rounded-xl border border-main-border p-4 shadow-sm">
                    <ul className="flex flex-col gap-2">
                        <li>
                            <NavButton to="/policy" btnName="Privacy Policy" selectState={selectState === "policy"} />
                        </li>
                        <li>
                            <NavButton to="/policy/terms" btnName="Terms & Conditions" selectState={selectState === "terms"} />
                        </li>
                        <li>
                            <NavButton to="/policy/ios" btnName="Privacy Policy (iOS)" selectState={selectState === "iospolicy"} />
                        </li>
                        <li>
                            <NavButton to="/policy/terms/ios" btnName="Terms & Conditions (iOS)" selectState={selectState === "iosterms"} />
                        </li>
                    </ul>

                    {/* Mobile action button */}
                    <div className="sm:hidden mt-4 pt-4 border-t border-main-border">
                        <button onClick={onClick} disabled={disabled} className={`${className} w-full justify-center`}>
                            <div className="flex items-center justify-center gap-2">
                                {icon}
                                <span>{label}</span>
                            </div>
                        </button>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Policy_Navbar;
